import babelpolyfill from 'babel-polyfill'; // eslint-disable-line
import './assets/css/bulma.css'
import Vue from 'vue'
import router from './router'
import store from './store'
import App from './App'
import ElementUI from 'element-ui'
import ewxLoginSDK from '@qtt/ewx-login-sdk'
import './assets/element-green/index.css'
import { sync } from 'vuex-router-sync'
import Auth from './core/Auth'
import Query from './common/js/Query'
import { Api } from './common/js/Api'
import 'font-awesome/css/font-awesome.min.css'
import ApiDomain from './core/ApiDomain'
import QuRequest from '@/core/QuRequest'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import ShortKey from './common/js/ShortKey'
import MessageBoxOwn from './common/js/MessageBoxOwn'

import { TOGGLE_SIDEBAR, SET_TOKEN } from 'vuex-store/mutation-types'

NProgress.configure({
    easing: 'ease', // 动画方式
    speed: 500, // 递增进度条的速度
    showSpinner: false, // 是否显示加载ico
    trickleSpeed: 200, // 自动递增间隔
    minimum: 0.3 // 初始化时的最小百分比
})

Vue.use(ElementUI)
// Vue.use(Router)
Vue.router = router
Vue.use(ShortKey)
Vue.use(Query)

Vue.use(MessageBoxOwn)
// Enable devtools
Vue.config.devtools = true

sync(store, router)

Vue.prototype.$http = new QuRequest()

const { state } = store

// 从 cookie 中恢复 token
store.commit(SET_TOKEN, Auth.getToken())

// const router = new Router(routerMap)

router.beforeEach((to, from, next) => {
    Api.update(to.query)
    ApiDomain.setApiBranch(to.query)
    if (state.app.device.isMobile && state.app.sidebar.opened) {
        store.commit(TOGGLE_SIDEBAR, false)
    }
    NProgress.start()
    if (to.fullPath === '/login' || from.fullPath === '/login') {
        next()
    } else {
        ewxLoginSDK.getUserInfo({ isPerm: true }).then(res => {
            if (!res) {
                next('/login')
            } else {
                next()
            }
        })
    }
})
router.afterEach(() => {
    // 在即将进入新的页面组件前，关闭掉进度条
    NProgress.done()
})

Vue.mixin({
    created() {
        if (this.filter) {
            this.filter = this.queryFilter()
            this.updateRouter(this.filter)
        }
    },
    methods: {
        $blockRequest({ $elem, req, pendingText = '操作中' }) {
            if (!$elem) {
                $elem = document.createElement('button')
            }
            if (!$elem || $elem._req_block) return

            let isButton = $elem.nodeName.toLowerCase() === 'button'
            let oText = $elem.innerText

            if (isButton) $elem.setAttribute('disabled', true)

            $elem.innerText = pendingText
            $elem._req_block = true

            return req.fin(() => {
                if (isButton) $elem.removeAttribute('disabled')
                $elem._req_block = false
                $elem.innerText = oText
            })
        }
    }
})

// Warn if overriding existing method
if (Array.prototype.equals) {
    console.warn(
        "Overriding existing Array.prototype.equals. Possible causes: New API defines the method, there's a framework conflict or you've got double inclusions in your code."
    )
}
// attach the .equals method to Array's prototype to call it on any array
Array.prototype.equals = function(array) {
    // if the other array is a falsy value, return
    if (!array) {
        return false
    }

    // compare lengths - can save a lot of time
    if (this.length !== array.length) {
        return false
    }

    for (var i = 0, l = this.length; i < l; i++) {
    // Check if we have nested arrays
        if (this[i] instanceof Array && array[i] instanceof Array) {
            // recurse into the nested arrays
            if (!this[i].equals(array[i])) {
                return false
            }
        } else if (this[i] !== array[i]) {
            // Warning - two different object instances will never be equal: {x:20} != {x:20}
            return false
        }
    }
    return true
}
// Hide method from for-in loops
Object.defineProperty(Array.prototype, 'equals', { enumerable: false })

new Vue({
    router,
    store,
    // i18n,
    render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js